import React from 'react'
import theme from '~/style/theme'

const LeftArrow = ({ color }) => {
  return (
    <svg width="12px" height="19px" viewBox="0 0 12 19" version="1.1">
      <g
        id="desktop"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="New-flow_05_multiplelawyer"
          transform="translate(-268.000000, -347.000000)"
          stroke={color}
          strokeWidth="3"
        >
          <g
            id="Group-13-Copy"
            transform="translate(275.000000, 356.000000) scale(-1, 1) translate(-275.000000, -356.000000) translate(251.000000, 332.000000)"
          >
            <polyline id="Path-3" points="21 17 29 24.5 21 32" />
          </g>
        </g>
      </g>
    </svg>
  )
}

LeftArrow.defaultProps = {
  color: theme.colors.text.inputPlaceholder
}

export default LeftArrow
